import { render } from "./DialogUtente.vue?vue&type=template&id=22a8854a&scoped=true"
import script from "./DialogUtente.vue?vue&type=script&lang=js"
export * from "./DialogUtente.vue?vue&type=script&lang=js"

import "./DialogUtente.vue?vue&type=style&index=0&id=22a8854a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a8854a"]])

export default __exports__